import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function OrderSuccess() {
  const orderNumber = `ORD-${Date.now().toString().slice(-8)}`;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl shadow-lg p-12">
            <div className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(217, 138, 30, 0.1)' }}>
              <i className="ri-checkbox-circle-fill text-5xl" style={{ color: '#D98A1E' }}></i>
            </div>
            
            <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: "'Tajawal', sans-serif", color: '#111111' }}>
              تم تأكيد طلبك بنجاح!
            </h1>
            
            <p className="text-lg mb-6" style={{ color: '#6B7280' }}>
              شكراً لك على طلبك. سنقوم بإرسال تفاصيل الشحن إلى بريدك الإلكتروني.
            </p>

            <div className="rounded-xl p-6 mb-8" style={{ backgroundColor: '#F5F7FA' }}>
              <p className="text-sm mb-2" style={{ color: '#6B7280' }}>رقم الطلب</p>
              <p className="text-2xl font-bold" style={{ color: '#D98A1E' }}>{orderNumber}</p>
            </div>

            <div className="space-y-4 mb-8">
              <div className="flex items-center justify-center gap-3" style={{ color: '#6B7280' }}>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-truck-line text-xl"></i>
                </div>
                <span>سيتم شحن طلبك خلال 2-5 أيام عمل</span>
              </div>
              <div className="flex items-center justify-center gap-3" style={{ color: '#6B7280' }}>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <span>ستصلك رسالة تأكيد على بريدك الإلكتروني</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/products" 
                className="px-8 py-4 text-white font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#8B1E12' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#A32618'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#8B1E12'}
              >
                متابعة التسوق
              </Link>
              <Link 
                to="/" 
                className="px-8 py-4 border-2 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                style={{ borderColor: '#E5E7EB', color: '#111111' }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#D98A1E'; e.currentTarget.style.color = '#D98A1E'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#E5E7EB'; e.currentTarget.style.color = '#111111'; }}
              >
                العودة للرئيسية
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
